module.exports = __webpack_public_path__ + "static/pic02-a7a16c51a2d10ad12e224a16d7dd9485.svg";